import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { getPasswordFormatValidationStatus } from '../../common/util/validatorUtil';
import { completeNewPassword } from '../../store/routines';
import PasswordSetup from './PasswordSetup';

function ChangePasswordForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [passwordValidationStatus, setPasswordValidationStatus] = useState(
    getPasswordFormatValidationStatus('')
  );

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isError);
  const username = useSelector((state) => state.auth.username);
  const temporaryPassword = useSelector(
    (state) => state.auth.temporaryPassword
  );

  if (!username) {
    history.replace('/login');
  }

  const onPasswordChangeFinish = (values) => {
    dispatch(
      completeNewPassword({
        username,
        password: temporaryPassword,
        newPassword: values.password,
      })
    );
  };
  const formValidator = (hangedValues) => {
    if ('password' in hangedValues) {
      setPasswordValidationStatus(
        getPasswordFormatValidationStatus(hangedValues.password)
      );
    }
  };
  return (
    <>
      <div className="login-input-wrapper">
        <div className="title smaller">Change your password</div>
        <div className="subtitle">
          Choose a new password. Make sure it&apos;s a strong one!
        </div>
        <Form
          name="login_step_1"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onPasswordChangeFinish}
          onValuesChange={formValidator}
        >
          {isError && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />{' '}
              {errorMessage}
            </div>
          )}
          <PasswordSetup validationStatus={passwordValidationStatus} />
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={Object.values(passwordValidationStatus).some(
                (element) => element === false
              )}
              className="login-form-button loginbtn"
            >
              Continue
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="filler"> </div>
    </>
  );
}

export default ChangePasswordForm;
